export const clientConstants = {
  CLIENTS_LOADED: 'CLIENTS_LOADED',
  CLIENT_LOADED: 'CLIENT_LOADED',
  CLIENT_CREATED: 'CLIENT_CREATED',
  CLIENT_UPDATED: 'CLIENT_UPDATED',
  CLIENT_DELETED: 'CLIENT_DELETED',
  CLIENT_ERRORS: 'CLIENT_ERRORS',
  CLIENT_RESET: 'CLIENT_RESET'
};



// WEBPACK FOOTER //
// ./src/_constants/client.constants.js